export class MediaUploaderService {
  callbackFunctions = []

  addOnResetFunction(callbackFunction: () => void) {
    this.callbackFunctions.push(callbackFunction)
  }

  reset() {
    this.callbackFunctions.forEach((callbackFunction) => {
      callbackFunction()
    })
  }
}
